import React from 'react';
import cn from 'classnames';

import { Button as AntButton } from 'antd';
import type { ButtonProps } from 'antd/lib/button';

import styles from './Button.module.scss';

export interface IButtonProps extends ButtonProps {}

const Button: React.FC<IButtonProps> & {
  __ANT_BUTTON: boolean;
} = ({ className, ...restProps }) => {
  return <AntButton className={cn(styles.Button, className)} {...restProps} />;
};

/* eslint no-underscore-dangle: 0 */
Button.__ANT_BUTTON = true;

export { Button };
